/* eslint-disable */
// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.

const awsmobile = {
  aws_project_region: "ap-southeast-1",
  aws_appsync_graphqlEndpoint:
    "https://hvzqkd2o7jg5bovrl26sixw6ku.appsync-api.ap-southeast-1.amazonaws.com/graphql",
  aws_appsync_region: "ap-southeast-1",
  aws_appsync_authenticationType: "API_KEY",
  aws_appsync_apiKey: "da2-flg3hncfhnav7opuwchkf6sdji",
  aws_cognito_identity_pool_id:
    "ap-southeast-1:153a0f10-4b0d-4062-b587-a6b966b305c2",
  aws_cognito_region: "ap-southeast-1",
  aws_user_pools_id: "ap-southeast-1_5dk5esDmV",
  aws_user_pools_web_client_id: "6iac1scpenikc9idfjieanhacs",
  oauth: {
    domain:
      "ap-southeast-15dk5esdmv.auth.ap-southeast-1.amazoncognito.com",
  },
  aws_cognito_username_attributes: ["EMAIL"],
  aws_cognito_social_providers: [],
  aws_cognito_signup_attributes: ["EMAIL"],
  aws_cognito_mfa_configuration: "OFF",
  aws_cognito_mfa_types: [],
  aws_cognito_password_protection_settings: {
    passwordPolicyMinLength: 8,
    passwordPolicyCharacters: [
      "REQUIRES_LOWERCASE",
      "REQUIRES_UPPERCASE",
      "REQUIRES_NUMBERS",
      "REQUIRES_SYMBOLS",
    ],
  },
  aws_cognito_verification_mechanisms: ["EMAIL"],
  aws_user_files_s3_bucket: "acesv2s3uploads54431-production",
  aws_user_files_s3_bucket_region: "ap-southeast-1",
};

export default awsmobile;
